import "./styles.css";
import PhoneInput, { parsePhoneNumber, getCountries, getCountryCallingCode , isValidPhoneNumber, isPossiblePhoneNumber } from "react-phone-number-input";
import ar from "react-phone-number-input/locale/ar";

const PhoneField = ({ onChange, defaultCountry = "EG" ,phone,phone_code ,setErrors}) => {
  const handleChange = (value) => {
    if (!value) {
      onChange({ phone: "", phone_code: "" });   
      return;
    }

    const parsed = parsePhoneNumber(value);
 const isPossible = isPossiblePhoneNumber(value);
  const isValid = isValidPhoneNumber(value);
    if (parsed) {
   
      onChange({
        phone: parsed.nationalNumber,
        phone_code: `+${parsed.countryCallingCode}`,
      });

    }

   
  if (!isPossible) {
    setErrors((prev) => ({
      ...prev,
      phone: ["رقم الهاتف غير مكتمل"],
    }));
    return;
  }

 
  if (!isValid) {
    setErrors((prev) => ({
      ...prev,
      phone: ["رقم الهاتف غير صالح"],
    }));
    return;
  }
         setErrors((prev)=>({...prev ,phone:""}))
  };

  const customLabels = {};
  getCountries().forEach((country) => {
    const code = getCountryCallingCode(country);
    customLabels[country] = `${ar[country] || country} (+${code})`;
  });
  const value = (phone && phone_code )? `${phone_code}${phone}` : "";
  
  return (
    <>
      <label htmlFor="" className="form-label">
        رقم الهاتف
      </label>
      <PhoneInput
      value={value}
        labels={customLabels}
        defaultCountry={defaultCountry}
        placeholder="ادخل رقم الهاتف"
        onChange={handleChange}
        displayInitialValueAsLocalNumber={false} // ensures the country code shows
          countrySelectProps={{
         native:false
          
        }}
           international
      />
   { phone.length > 0 &&  <span className={isValidPhoneNumber(value)?"text-green":"text-danger"}>{( isValidPhoneNumber(value) )? " الرقم صالح" :"رقم غير صالح"}</span>}
    </>
  );
};

export default PhoneField;
